import { nameValuePair } from '../../models/common.model';

export const encryptionKeys = {
  IV: '',
  key: ''
};

export const SignUpType = {
  Email: 1,
  Phone: 2
};

export const ProcessType = {
  Forget: 1,
  Verify: 2,
  SignUp: 3,
  Login: 4,
  Profile: 5
};

export const columnValueType = {
  Nothing: 0,
  SlideToggle: 1,
  Action: 2,
  Object: 3,
  Select: 4,
  Button: 5
};

export const InitialScreenTab = {
  STUDENTORPARENT: 1,
  TUTORORCOUNSLER: 2
};

export const UserRole = {
  ADMIN: 1,
  STUDENT: 2,
  TUTOR: 3,
  COUNSELOR: 4,
  PARENT: 5,
  SUBADMIN: 6
};

export const Gender = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3
};

export const EMPLOYMENT_TYPE = {
  SELF_EMPLYED: 1,
  INSTITUTION: 2,
  COACHING_CENTER: 3
};

export const ACADEMIC_TYPE = {
  SCHOOL: 1,
  UNIVERSITY: 2
};

export const TUTOR_MODE = {
  VIRTUAL: 1,
  IN_PERSON: 2,
  BOTH: 3
};

export const StudentParentRelation = {
  FATHER: 1,
  MOTHER: 2,
  OTHER: 3
};

export const BufferTime: Array<nameValuePair> = [
  {
    value: '1',
    name: '1minute'
  },
  {
    value: '2',
    name: '2minutes'
  },
  {
    value: '3',
    name: '3minutes'
  },
  {
    value: '4',
    name: '4minutes'
  },
  {
    value: '5',
    name: '5minutes'
  },
  {
    value: '6',
    name: '6minutes'
  },
  {
    value: '7',
    name: '7minutes'
  },
  {
    value: '8',
    name: '8minutes'
  },
  {
    value: '9',
    name: '9minutes'
  },
  {
    value: '10',
    name: '10minutes'
  },
  {
    value: '11',
    name: '11minutes'
  },
  {
    value: '12',
    name: '12minutes'
  }
];

export const Modes: Array<nameValuePair> = [
  {
    value: '1',
    name: 'Virtual'
  },
  {
    value: '2',
    name: 'Physical'
  },
  {
    value: '3',
    name: 'Both'
  }
];


export const DaysData: Array<nameValuePair> = [
  {
    name: 'Monday',
    value: '1'
  },
  {
    name: 'Tuesday',
    value: '2'
  },
  {
    name: 'Wednesday',
    value: '3'
  },
  {
    name: 'Thursday',
    value: '4'
  },
  {
    name: 'Friday',
    value: '5'
  },
  {
    name: 'Saturday',
    value: '6'
  },
  {
    name: 'Sunday',
    value: '7'
  }
];


export const statusKey : Array<nameValuePair> = [
  {
    name:'Upcoming',
    value: '2'

  },
  {
    name:'Pending',
    value: '0'
  },
  {
    name:'Completed',
    value: '3'
  }
];

export const PACKAGE_SERVICE_TYPE_ARRAY : Array<nameValuePair> = [
  {
    name:'Tutoring Session',
    value:'1'
  },
  {
    name:'Counselling',
    value:'2'
  }

];

export const PACKAGE_SERVICE_TYPE = {
  TUTORING: 1,
  COUNSELLING: 2
};

export const PACKAGE_TYPE = {
  ONE_TIME: 1,
  RECURRING: 2
};

export const PACKAGE_VISIBILITY = {
  NEW: 1,
  EXTENT_CURRENT: 2
};

export const PROMO_TYPE = {
  FIXED: 1,
  PERCENTAGE: 2
};

export const ConsultationType = {
  Paid: 1,
  Free: 2
};

export const SESSION_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  ONGOING: 2,
  COMPLETED: 3,
  CANCELLED: 4,
  RESCHEDULED: 5
};

export const StudentAddEdit = {
  Add: 1,
  Edit: 2
};
